<template>
  <div class="container my-3">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <CustomAlert type="warning" icon="" class="mb-5 fs-5" v-if="isClosed">
          <p class="mb-0">The House Competition has closed.</p>
        </CustomAlert>

        <CodeValidator :code="code" v-else />
      </div>
    </div>
  </div>
</template>

<script>
import CodeValidator from "@/components/reward/CodeValidator.vue";

export default {
  name: "RewardView",
  components: {
    CodeValidator
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  computed: {
    isClosed() {
      return false;
    }
  },
  mounted() {
    history.pushState({}, "", "/#/reward/");
  }
};
</script>
